import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const PARLAY_STORAGE_KEY = 'isParlayEnabled';

interface ParlayState {
  isParlayEnabled: boolean;
}

const getInitialParlayState = (): boolean => {
  if (typeof window === 'undefined') return false;

  return window.localStorage.getItem(PARLAY_STORAGE_KEY) === 'true';
};

const initialState: ParlayState = {
  isParlayEnabled: getInitialParlayState(),
};

export const parlaySlice = createSlice({
  name: 'parlay',
  initialState,
  reducers: {
    setParlayEnabled: (state, action: PayloadAction<boolean>) => {
      state.isParlayEnabled = action.payload;
    },

    toggleParlay: (state) => {
      state.isParlayEnabled = !state.isParlayEnabled;
    },
  },
});

export const { setParlayEnabled, toggleParlay } = parlaySlice.actions;

export default parlaySlice.reducer;
